import { isNumber, isObject, isString } from 'lodash'
import { remToPx } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { type MarginProps } from 'styled-system'
import { Image, IMAGE_LAYOUT } from 'components/Image'
import { Box } from 'components/Layout'
import { ASPECT_RATIO } from 'components/UploadImage/constants'
import { SPACE, IMAGE_BASE_WIDTH, RADIUS } from 'Theme'
import { useMedia } from 'useMedia'

const StyledImage = styled(Image)`
  border-radius: ${RADIUS.PX_6};
`

interface ProductImageProps extends MarginProps {
  src?: string
  alt: string
  width:
    | string
    | number
    | {
        MOBILE: string
        TABLET: string
      }
}

export const ProductImage: React.FC<ProductImageProps> = ({
  src,
  alt,
  width,
  ...props
}) => {
  const media = useMedia()
  let baseWidth: number | string = IMAGE_BASE_WIDTH.PX_320
  if (isNumber(width)) {
    baseWidth = width
  } else if (isObject(width) && (media.MOBILE || media.TABLET)) {
    baseWidth = Number(
      remToPx(media.MOBILE ? width.MOBILE : width.TABLET).slice(0, -2)
    )
  } else if (isString(width)) {
    baseWidth = remToPx(width).slice(0, -2)
  }

  return (
    <Box m={SPACE.PX_5} height="auto" width={width} {...props}>
      <StyledImage
        layout={IMAGE_LAYOUT.RESPONSIVE}
        src={src}
        alt={alt}
        objectFit="cover"
        baseWidth={IMAGE_BASE_WIDTH.PX_320}
        requestWidth={baseWidth}
        aspectRatio={ASPECT_RATIO.PRODUCTS}
      />
    </Box>
  )
}
